exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*!\n* ORDER LIST SECTION STYLES\n*/.SectionMyOrders .items-detailed-listing{margin-top:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./customer/sections/order/order-list.useable.scss
// module id = 729
// module chunks = 0